<template>
  <div class="latest-news__cards">
    <template v-for="(result, r) in results" :key="r">
      <div class="latest-news__card">
        <a :href="`/${$filters.convertResourceType(result['resource-type'])}/${result['slug']}`">
          <div class="img-container">
            <img :src="`${$filters.analyseImage(result['cover-image'],'herosearchxs','herosearchsm')}`" alt="">
          </div>

          <div class="body">
            <div class="body__group" @click.prevent="doLike">
              <h4 class="body__title">{{ result['title'] }}</h4>
              <svg-heart></svg-heart>
              <!-- <block-alert-like :org_main_id="result['org-main-id']" :org_name="result['org-name']"></block-alert-like> -->
            </div>

            <p class="body__paragraph">{{ truncate(result['summary']) }}</p>

            <div class="body__footer-group">
              <p class="date">{{ $filters.ukDate(result['publish-date']) }}</p>
              <span class="arrow">
                <svg-arrow-long></svg-arrow-long>
              </span>
            </div>
          </div>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'resources-dev' : 'resources-live',
				searchObject: {
					hitsPerPage: 3,
					facets: [],
					facetFilters: []
				},
				results: false
			}
		},

		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);

			this.index
				.search('', this.searchObject)
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					// console.log("resources you might like search raw results:", results);
					if (results.nbHits > 0) {
						this.results = results.hits;
					} else {
						this.results = false;
					}
				});
		},

    methods: {
      doLike() {
        alert('Likey Likey...');
      },
      truncate(input, num = 45) {
        return input.split(' ').length <= num ? input : input.split(' ').slice(0, num).join(' ')+'...';
      }
    }
	}
</script>
